import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import moment from 'moment';
import {
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import getTranslatedText from '../../../../services/getTranslatedText';

import saddestSmiley from '../../../../img/smileys/saddest.svg';
import sadSmiley from '../../../../img/smileys/sad.svg';
import happySmiley from '../../../../img/smileys/happy.svg';
import happiestSmiley from '../../../../img/smileys/happiest.svg';

import star1 from '../../../../img/stars/1.png';
import star2 from '../../../../img/stars/2.png';
import star3 from '../../../../img/stars/3.png';
import star4 from '../../../../img/stars/4.png';
import star5 from '../../../../img/stars/5.png';

import { injectIntl } from 'react-intl';
import _ from 'lodash';
import {
  QUESTION_TYPE_COMMENT,
  QUESTION_TYPE_FIVESTARS,
  QUESTION_TYPE_NUMBER,
  QUESTION_TYPE_SHORTTEXT,
  QUESTION_TYPE_SMILEYCOMMENT,
  QUESTION_TYPE_SMILEYQUARTET,
  QUESTION_TYPE_TYPEAHEAD,
  QUESTION_TYPE_YESNO,
} from '../../../../constants';

const starImages = {
  1: star1,
  2: star2,
  3: star3,
  4: star4,
  5: star5,
};

const smileyImages = {
  1: saddestSmiley,
  2: sadSmiley,
  3: happySmiley,
  4: happiestSmiley,
};

function getExtraColumnAnswer(questionId, responderAnswers, intl) {
  const responderAnswer = _.find(responderAnswers, (ra => ra.questionMongoId === questionId));
  if (!questionId || !responderAnswer) {
    return '';
  }
  const yesNoCategories = {
    1: intl.formatMessage({
      id: 'no',
      defaultMessage: 'No',
    }),
    2: intl.formatMessage({
      id: 'yes',
      defaultMessage: 'Yes',
    }),
  };
  switch (responderAnswer.questionType) {
    case QUESTION_TYPE_SMILEYQUARTET:
    case QUESTION_TYPE_SMILEYCOMMENT:
      return (
        <img
          width="22px"
          height="22px"
          alt={responderAnswer.selectedOptions[0]}
          src={smileyImages[responderAnswer.selectedOptions[0]]}
        />
      );
    case QUESTION_TYPE_FIVESTARS:
      return (
        <img
          width="22px"
          height="22px"
          alt={responderAnswer.selectedOptions[0]}
          src={starImages[responderAnswer.selectedOptions[0]]}
        />
      );
    case QUESTION_TYPE_YESNO:
      return yesNoCategories[responderAnswer.selectedOptions[0]];
    case QUESTION_TYPE_COMMENT:
    case QUESTION_TYPE_SHORTTEXT:
    case QUESTION_TYPE_TYPEAHEAD:
    case QUESTION_TYPE_NUMBER:
    case 'email':
      return responderAnswer.comment;
    default:
      const selectedOption = _.find(
        responderAnswer.questionOptions,
        (option => option.value === responderAnswer.selectedOptions[0])
      );
      return getTranslatedText(selectedOption.text, intl.locale) || responderAnswer.selectedOptions[0];
  }
}

@injectIntl
class CommentsWidgetListItem extends Component {
  render() {
    const styles = {
      tableRow: {
        height: 'auto',
      },
      tableCell: {
        boxSizing: 'border-box',
        height: 'auto',
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 5,
        paddingRight: 5,
        msWordBreak: 'break-all',
        msWordWrap: 'break-all',
        WebkitWordBreak: 'break-word',
        WebkitWordWrap: 'break-word',
        wordBreak: 'break-word',
        wordWrap: 'break-word',
        WebkitHyphens: 'auto',
        MozHyphens: 'auto',
        hyphens: 'auto',
        whiteSpace: 'normal',
      },
      timeCell: {
        width: this.props.columnWidths.time,
      },
      deviceCell: {
        width: this.props.columnWidths.device,
      },
      extraColumnCell: {
        width: this.props.columnWidths.extraColumn,
      },
      smileyCommentCell: {
        paddingTop: 5,
        paddingBottom: 5,
        width: this.props.columnWidths.smileyComment,
      },
      commentCell: {
        width: this.props.columnWidths.comment,
      },
    };

    const {
      answer,
      relay,
      columnWidths,
      showTerminalColumn,
      showTimeColumn,
      showLocation,
      showSmileyComment,
      extraColumns,
      intl,
      ...tableProps,
    } = this.props;

    const deviceName = answer.device && answer.device.name;
    const deviceLocation = answer.device && answer.device.location;

    return (
      <TableRow style={styles.tableRow} {...tableProps}>
        {showTimeColumn && (
          <TableRowColumn style={Object.assign({}, styles.tableCell, styles.timeCell)}>
            {moment.utc(answer.localTime).format('ddd, D MMM Y, HH:mm')}
          </TableRowColumn>
        )}
        {showTerminalColumn && (
          <TableRowColumn style={Object.assign({}, styles.tableCell, styles.deviceCell)}>
            {showLocation ? (deviceLocation || deviceName) : deviceName}
          </TableRowColumn>
        )}
        {extraColumns && extraColumns.map(column =>
          <TableRowColumn
            key={column.questionId}
            style={Object.assign({}, styles.tableCell, styles.extraColumnCell)}
          >
            {getExtraColumnAnswer(column.questionId, answer.responderAnswers, intl)}
          </TableRowColumn>
        )}
        {showSmileyComment && (
          <TableRowColumn style={Object.assign({}, styles.tableCell, styles.smileyCommentCell)}>
            {answer.selectedOptions && answer.selectedOptions[0] && (
              <img
                width="22px"
                height="22px"
                alt={answer.selectedOptions[0]}
                src={smileyImages[answer.selectedOptions[0]]}
              />
            )}
          </TableRowColumn>
        )}
        <TableRowColumn style={Object.assign({}, styles.tableCell, styles.tableCell)}>
          {answer.comment}
        </TableRowColumn>
      </TableRow>
    );
  }
}

export default createFragmentContainer(
  CommentsWidgetListItem,
  graphql`
    fragment CommentsWidgetListItem_answer on Answer {
      id
      localTime
      comment
      selectedOptions
      device {
        name
        location
      }
      responderAnswers {
        questionMongoId
        questionText {
          language
          text
        }
        questionType
        questionOptions {
          value
          text {
            language
            text
          }
        }
        comment
        selectedOptions
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/CommentsWidgetList/components/CommentsWidgetListItem/CommentsWidgetListItem.js